<template>
    <div>
        <TheHeader class="pc-header"  />
        <div class="banner">
            <img v-if="infor.banner!=null && infor.banner!=''" :src="infor.banner">

            <template v-else-if="infor.video!=null && infor.video!=''">
                <img 
                    class="video-cover" 
                    v-if="videoCover" 
                    :src="'./images/detail/media-cover.png'"
                >
                <img 
                    class="video-play" 
                    v-if="!videoPlay" 
                    src="@/assets/images/base-play.png"  
                    :class="{played: !videoCover}"
                    @click="playVideo"
                >
                <!-- <img 
                    class="video-pause" 
                    v-else-if="videoPlay" 
                    src="@/assets/images/base-pause.png"
                    @click="pauseVideo"
                > -->
                <video 
                    controls
                    controlslist="nodownload" 
                    ref="detaliTopVideo" 
                    class="banner-video"
                    :src="infor.video" 
                ></video>
            </template>
        </div>
        <BaseTitle :infor="infor" />
        <BaseArcticle :list="infor.list" />

        <BasePageTurning :infor="infor" />

        <TheFooter class="pc-the-footer-other" />
        
    </div>
</template>
<script>
    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-other_pc-the-footer-other.less'
    
    import BaseTitle from '@/components/module/BaseTitle'
    import BaseArcticle from '@/components/module/BaseArcticle'
    import BasePageTurning from '@/components/module/BasePageTurning'

    export default {
        name: 'PCDetail',
        props: {
            infor: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseArcticle,
            BasePageTurning
        },
        data () {
            return {
                videoPlay: false,
                videoCover: true
            }
        },
        mounted () {},
        methods: {
            initVideo: function(){
                let _this = this;
                let video = this.$refs.detaliTopVideo;
                if(video){
                    video.addEventListener('pause',function(){
                        _this.videoPlay = false;
                    });
                    video.addEventListener('play',function(){
                        _this.videoPlay = true;
                    });
                }
            },
            playVideo: function(){
                let dom = this.$refs.detaliTopVideo;
                dom.style.height = 'auto';
                dom.play();
                this.videoCover = false;
                this.videoPlay = true;
                // this.initVideo();

            },
            pauseVideo: function(){
                let dom = this.$refs.detaliTopVideo;
                dom.pause();
                this.videoPlay = false;
            } 
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*导航*/
.banner {
    position: relative;
    text-align: center;
    overflow: hidden;
}
.video-cover {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 50%;
    width: 1920px;
    height: 560px;
    margin-left: -960px;
}
.video-pause,
.video-play {
    position: absolute;
    z-index: 12;
    top: 50%;
    left: 50%;
    width: 90px;
    height: 90px;
    margin: -45px 0 0 -45px;
    cursor: pointer;
}
.video-pause,
.video-play.played {
    display: none;
}
.banner:hover .video-play.played,
.banner:hover .video-pause {
    display: block;
}

.example-title {
    padding: 12px 0 50px;
}

.title-box {
    padding-top: 50px;
    padding-bottom: 30px;
}
.banner-video {
    width: 100%;
    height: 560px;
    /*object-fit: contain;*/
    background: #000;
}


</style>
